export const LetterType = {
  PrevailingWage: 'PERM Job Description Draft',
  Recruitment: 'PERM Recruitment Report Template'
}
